// Add English game HRUs here to enable SSR personalized recommendations for the experiment.
const PERSONALIZED_RECOMMENDATIONS_SSR_HRUS = [
    'fragen',
    'your-obby-escape',
    'car-crush-realistic-destruction',
    'idol-livestream-doll-dress-up',
    'sprunki-2c27-1',
    'granny-original',
    'solitaire-classic-klondike',
    'good-sort-master',
    'basket-random',
    'my-perfect-farm-idle-tycoon',
]

export const hasPersonalizedRecommendationsSSR = (hru: string) => PERSONALIZED_RECOMMENDATIONS_SSR_HRUS.includes(hru)

export const isPersonalizedRecommendationsSSRPath = (pathname: string) => {
    const match = /^\/game\/([^/]+)$/.exec(pathname)
    return match ? hasPersonalizedRecommendationsSSR(match[1]!) : false
}
